import axios from "axios";
import { getReturnUrl } from "./SingletonStore";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

let isRefreshing = false;
let failedQueue: any[] = [];

export const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
});

const processQueue = (error: any, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) prom.reject(error);
    else prom.resolve(token);
  });
  failedQueue = [];
};

axiosInstance.interceptors.request.use(
  (request) => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      request.headers["Authorization"] = `Bearer ${accessToken}`;
    }
    return request;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    if (error.response.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({
            resolve: (token: string) => {
              originalRequest.headers["Authorization"] = `Bearer ${token}`;
              resolve(axiosInstance(originalRequest));
            },
            reject: (err: any) => reject(err),
          });
        });
      }

      originalRequest._retry = true; // Mark the request as retried to avoid infinite loops.
      isRefreshing = true;

      try {
        const refreshToken = localStorage.getItem("refreshToken");
        const oldAccessToken = localStorage.getItem("accessToken");
        const response = await axios.post(
          `${API_BASE_URL}/api/v1/auth/refresh-token`,
          {
            token: refreshToken,
          },
          {
            headers: { Authorization: `Bearer ${oldAccessToken}` },
          }
        );
        const { accessToken, refreshToken: newRefreshToken } = response.data;
        localStorage.setItem("accessToken", accessToken);
        localStorage.setItem("refreshToken", newRefreshToken);
        axiosInstance.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${accessToken}`;
        processQueue(null, accessToken);
        originalRequest.headers["Authorization"] = `Bearer ${accessToken}`;
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        console.error("Token refresh failed:", refreshError);
        processQueue(refreshError);
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        const returnUrl = getReturnUrl();
        returnUrl ?
          window.location.replace(
            `/signin?returnUrl=${encodeURIComponent(returnUrl)}`
          ) : window.location.replace("/signin");
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    } else if (error.response.status === 403 && error.response.data.title === "Forbidden") {
      window.location.replace("/all-orders");
    } else if (error.response.status === 404 && error.response.data.detail === "Record not found") {
      window.location.replace("/all-orders");
    }
    return Promise.reject(error);
  }
);
